import React from 'react';
import TextField from 'components/Typography/TextField';
import Icon from 'components/DesignSystem/Icon';
import Selector from 'components/DesignSystem/Selector';
import SortingArrow from 'components/SortingArrow';
import { Col } from 'react-bootstrap';
import Tooltip from 'components/Typography/Tooltip';
import { SortDirection } from 'constants/sorting';
import { cssVar } from 'constants/theme';
import './index.scss';

type SelectorValue = string | number | string[];

interface ColumnHeaderSelectSortProps<T extends SelectorValue> {
  title: string;
  children?: React.ReactNode;
  className?: string;
  value?: T;
  setValue?: React.Dispatch<React.SetStateAction<T>>;
  md: number;
  onSort?: (direction?: SortDirection) => void;
  sortDirection?: SortDirection;
}

export default function ColumnHeaderSelectSort<T extends SelectorValue>({
  title,
  children,
  className = '',
  value,
  setValue = () => {},
  md,
  onSort,
  sortDirection,
}: ColumnHeaderSelectSortProps<T>) {
  const filterIcon = (
    <Icon iconType="filter" color={cssVar('text-strong')} />
  );

  // Determinar se é multi-select baseado no tipo do value
  const isMultiSelect = Array.isArray(value);
  const defaultValue = (isMultiSelect ? [] : '') as T;
  const actualValue = value ?? defaultValue;

  // Calcular quantidade de itens selecionados para o badge
  let selectedCount = 0;
  if (isMultiSelect) {
    selectedCount = (actualValue as string[]).length;
  } else if (actualValue as string | number) {
    selectedCount = 1;
  }

  return (
    <Col md={md} className={`d-flex align-items-center justify-content-start gap-1 ${className}`}>
      {onSort && (
        <div className="ht-sort-button-container">
          <SortingArrow
            field={title as any}
            sortBy={title as any}
            sortDirection={sortDirection}
            sort={onSort}
          />
        </div>
      )}
      <TextField>{ title }</TextField>
      <div className="ht-filter-button-container">
        <Selector
          value={actualValue}
          setValue={setValue}
          search
          searchPlaceholder="Buscar opções"
          placeholder="Selecionar opção"
          selectAllLabel="Selecionar todos"
          selectedLabel="Selecionados"
          unselectedLabel="Disponíveis"
          containerClassName="ht-filter-selector"
          fixedTitle={filterIcon}
          clearOptionsButton
          clearOptionsLabel="Limpar seleção"
        >
          { children }
        </Selector>
        {selectedCount > 0 && (<Tooltip>{ selectedCount }</Tooltip>)}
      </div>
    </Col>
  );
}
